<template>
  <div class="header flex flex-space-between" :class="{white:navshow,small}" ref="header" id="header">
    <div class="logo">
      <img src="@/assets/logo.jpg" @click="gotoindex">
    </div>
    <transition name="el-zoom-in-top">
      <div class="nav flex flex-space-between el-zoom-in-top hidden-xs-only" v-show="navshow">
        <router-link to="/">{{ $t('nav.home') }}</router-link>
        <Aboutmenu />
        <Researchmenu />
        <Productmenu />
        <Newsmenu />
        <router-link to="/job">{{ $t('nav.job') }}</router-link>
        <router-link to="/contact">{{ $t('nav.contact') }}</router-link>
      </div>
    </transition>
    <div class="flex hidden-xs-only">
      <div class="left flex flex-align-center">
        <div class="search">
          <i class="el-icon-search" @click="searchShow=true"></i>
        </div>
        <div class="language">
          <el-dropdown @command="handleEarthDropdownClick">
            <span class="el-dropdown-link">
              {{ $t('chooseLanguage') }}
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
              command="en"
              :disabled="lang === 'en'">English</el-dropdown-item>
              <el-dropdown-item
              command="zh-CN"
              :disabled="lang === 'zh-CN'">简体中文</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="menu" @click="navshow=!navshow">
        <div class="navicon">
          <span></span>
          <span></span>
          <span></span>
        </div>
        MENU
      </div>
    </div>
    <SmallHeader class="flex flex-align-center hidden-sm-and-up" />
    <transition name="el-zoom-in-top">
      <Search class="transition-box" @searchClose="searchClose" v-show="searchShow"/>
    </transition>
  </div>
</template>

<script>
import Aboutmenu from "./Aboutmenu.vue"
import Productmenu from "./Productmenu.vue"
import Newsmenu from "./Newsmenu.vue"
import Researchmenu from "./Researchmenu.vue"
import Search from "./Search.vue"
import About from "@/views/about/About.vue"
import { mapState, mapActions } from 'vuex'
import { getProductstypeUrl } from '@/util/lang.js'
import Scrollbar from 'smooth-scrollbar';
import SmallHeader from './SmallHeader.vue'
export default {
  name: 'Header',
  data(){
    return{
      navshow: false,
      small: false,
      searchShow: false,
      scrollbar: ''
    }
  },
  components: {
    Aboutmenu,
    Productmenu,
    Newsmenu,
    Researchmenu,
    Search,
    SmallHeader
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      langProducttype: state => state.langProducttype
    })
  },
  watch: {
    $route: 'scroll'
  },
  methods: {
    ...mapActions([
      'setLang',
      'setLangProducttype'
    ]),
    handleEarthDropdownClick (command) {
      this.setLang(command)
      this.$i18n.locale = command

      const url = getProductstypeUrl(command)
      if (this.langProducttype[command].length === 0) {
        this.$$axios.get(url).then(res => {
          this.setLangProducttype({
            lang: command,
            productstype: res.data
          })
        })
      }
    },
    searchClose(){
      this.searchShow=false
    },
    gotoindex(){
      this.$router.push({
        name: 'home'
      })
    },
    scrollHeader(scrollTop){
      this.small=scrollTop>200 ? true : false
    },
    scroll(){
      this.scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
      let scrollHeader=this.scrollHeader
      if(this.scrollbar){
        this.scrollbar.addListener((status) => {
          scrollHeader(status.offset.y)
        });
      }
    }
  },
  mounted(){
    this.$nextTick(()=>{
      this.scroll()
    })
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header{
  position:fixed;
  top:0;
  left:0;
  width:100%;
  z-index: 999;
  transition: .3s;
}
.header.white{
  background-color: #fff;
}
.header .logo img{
  display: block;
  max-width: 280px;
  transition: all .3s;
  cursor: pointer;
}
.header.small .logo img{
  max-width: 200px;
}
.header .nav{
  flex: auto;
  padding: 0 20px;
  font-size: 16px;
}
.header .nav a{
  color: #000;
  transition: .3s;
  display: flex;
  align-items: center;
}
.header .nav a:hover{
  color: #004b94;
}
.nav .el-dropdown-link{
  cursor: pointer;
  font-size: 16px;
  color: #000;
  transition: .3s;
  display: flex;
  align-items: center;
  height: 100%;
}
.el-dropdown-link:hover{
  color: #004b94;
}
.header .search{
  border-right: 1px solid;
}
.header .search i{
  cursor: pointer;
}
.header .search, .header .language{
  font-size: 16px;
  color: #fff;
  padding-left: 10px;
  padding-right: 10px;
}
.header.white .search, .header.white .language{
  color: #004b94;
}
.header .language{
  background: url(/images/icon0.png)no-repeat left 10px center;
  padding-left: 30px;
  cursor: pointer;
}
.header.white .language,.header .language:hover{
  background-image: url(/images/icon0_h.png);
  color: #004b94;
}
.header .language .el-dropdown{
  font-size: inherit;
  color: inherit;
}
.header .left{
  margin-right: 50px;
}
.header .menu{
  background-color:#004b94;
  font-size: 16px;
  color: #c2daf1;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  cursor: pointer;
}
.header .menu img{
  margin-right: 10px;
}
.header .menu .navicon{
  position: relative;
  width: 21px;
  height: 21px;
  margin-right: 10px;
  /* overflow: hidden; */
}
.header .menu .navicon span{
  position: absolute;
  left: 0;
  height: 1px;
  background-color: #fff;
  transition: .3s;
}
.header .menu .navicon span:nth-of-type(1){
  width: 21px;
  top: 0;
}
.header .menu .navicon span:nth-of-type(2){
  width: 19px;
  top: 10px;
}
.header .menu .navicon span:nth-of-type(3){
  width: 15px;
  bottom: 0;
}
.header.white .menu .navicon span:nth-of-type(1){
  transform: rotate(45deg);
  transform-origin: 0 50%;
  width: 29px;
}
.header.white .menu .navicon span:nth-of-type(2){
  opacity: 0;
}
.header.white .menu .navicon span:nth-of-type(3){
  transform: rotate(-45deg);
  transform-origin: 0 50%;
  width: 29px;
}
@media (max-width: 768px){
  .header{
    background-color: #fff;
  }
  .header .logo img{
    max-height: 50px;
  }
  .header .left{
    margin-right: 20px;
  }
}
</style>

